export const emailTemplateTypeOptions = [
  { value: 1, label: "New User" },
  { value: 2, label: "New Student" },
  { value: 3, label: "New ESNcard Request" },
  { value: 6, label: "New ESNcard Request (PAID)" },
  { value: 4, label: "New Event Purchase Request" },
  { value: 5, label: "Event Ticket" },
  { value: 7, label: "Event Purchase Reminder" },
  { value: 8, label: "New Wishlist Entry" },
];

const emailTemplateTypeLabels = emailTemplateTypeOptions.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

export const getEmailTemplateTypeLabel = (type) => {
  const normalizedType = Number(type);
  return emailTemplateTypeLabels[normalizedType] || String(type);
};
